export const ELEMENT_NOTE = 'note';
